var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-wrapper field-wrapper--textarea",
      class: ["field-wrapper--" + _vm.field.size]
    },
    [
      _c(
        "div",
        {
          ref: "fieldGroup",
          staticClass: "field-group field-group--textarea",
          class: [
            { "field-group--error": _vm.isError },
            { "field-group--block-animated": _vm.text.length > 0 }
          ]
        },
        [
          _c(
            "label",
            {
              staticClass: "label",
              attrs: { for: "input_" + _vm.formId + "_" + _vm.field.id }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.field.label)),
              _vm.field.isRequired ? _c("sup", [_vm._v("*")]) : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.text,
                expression: "text"
              }
            ],
            attrs: {
              name: "input_" + _vm.field.id,
              required: _vm.field.isRequired,
              id: "input_" + _vm.formId + "_" + _vm.field.id,
              cols: "30",
              rows: "1"
            },
            domProps: { value: _vm.text },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.text = $event.target.value
                },
                _vm.textareaSize
              ],
              focus: _vm.inputFocus,
              blur: _vm.inputBlur
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm._t("description"),
      _vm._v(" "),
      _vm._t("error")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }